
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { MapPin, Loader2 } from "lucide-react";
import { useGeolocation } from "@/hooks/useGeolocation";
import { useToast } from "@/hooks/use-toast";

interface NearMeButtonProps {
  onLocationFound: (lat: number, lng: number) => void;
  disabled?: boolean;
}

const NearMeButton = ({ onLocationFound, disabled }: NearMeButtonProps) => {
  const { latitude, longitude, loading, error, getCurrentLocation } = useGeolocation();
  const { toast } = useToast();
  const [clicked, setClicked] = useState(false);

  const handleNearMeClick = () => {
    setClicked(true);
    getCurrentLocation();
  };

  // Handle location found
  if (clicked && latitude && longitude && !loading) {
    setClicked(false);
    onLocationFound(latitude, longitude);
    toast({
      title: "Location Found",
      description: "Searching for nearby parking spots...",
    });
  }

  // Handle location error
  if (clicked && error && !loading) {
    setClicked(false);
    toast({
      title: "Location Error",
      description: error,
      variant: "destructive",
    });
  }

  return (
    <Button
      onClick={handleNearMeClick}
      disabled={disabled || loading}
      variant="outline"
      className="flex items-center gap-2 bg-blue-50 hover:bg-blue-100 border-blue-200 text-blue-700 transition-all duration-300"
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <MapPin className="h-4 w-4" />
      )}
      {loading ? "Finding Location..." : "Near Me"}
    </Button>
  );
};

export default NearMeButton;
